
import { inject, Injectable } from "@angular/core";
import { ApiService } from "@tylertech/core-module";
import { AlertViewModel, EmployeeDeductionCodeTierVendorViewModel, EmployeeHistoryViewModel, EmployeeLeaveDetailViewModel, EmployeeLeaveViewModel, EmployeePayHistoryParms, EmployeePayHistoryViewModel, EmployeePaySummaryViewModel, EmployeeProfileSecurityViewModel, EmployeeProfileViewModel, ExecutionResult, IEmployeeSummaryViewModel, IEmployeeTaxViewModel } from "@tylertech/tyler-api-types";

/**
 * EmployeeManagerService is a generated service implementation. Any edits will be overridden!
 */
@Injectable()
export class EmployeeManagerService {
    private readonly $apiService = inject(ApiService);
    
    EmployeeHasSDI(employeeId: string): Promise<boolean> {
        return this.$apiService.sendAuth("IEmployeeManagerService/EmployeeHasSDI", employeeId);
    }
    GetEmployeeAlerts(employeeId: string): Promise<AlertViewModel[]> {
        return this.$apiService.sendAuth("IEmployeeManagerService/GetEmployeeAlerts", employeeId);
    }
    GetEmployeeCategoryCodes(): Promise<string[]> {
        return this.$apiService.sendAuth("IEmployeeManagerService/GetEmployeeCategoryCodes");
    }
    GetEmployeeDeductionCodeTierVendor(employeeDeductionCodeTierId: string): Promise<EmployeeDeductionCodeTierVendorViewModel> {
        return this.$apiService.sendAuth("IEmployeeManagerService/GetEmployeeDeductionCodeTierVendor", employeeDeductionCodeTierId);
    }
    GetEmployeeDepartmentCodes(employeeId: string): Promise<string[]> {
        return this.$apiService.sendAuth("IEmployeeManagerService/GetEmployeeDepartmentCodes", employeeId);
    }
    GetEmployeeHistory(employeeId: string): Promise<EmployeeHistoryViewModel[]> {
        return this.$apiService.sendAuth("IEmployeeManagerService/GetEmployeeHistory", employeeId);
    }
    GetEmployeeLeaveDetail(employeeLeaveId: string): Promise<EmployeeLeaveDetailViewModel[]> {
        return this.$apiService.sendAuth("IEmployeeManagerService/GetEmployeeLeaveDetail", employeeLeaveId);
    }
    GetEmployeeLeaveUsage(employeeId: string): Promise<EmployeeLeaveViewModel[]> {
        return this.$apiService.sendAuth("IEmployeeManagerService/GetEmployeeLeaveUsage", employeeId);
    }
    GetEmployeePayDetails(employeeId: string): Promise<EmployeePaySummaryViewModel> {
        return this.$apiService.sendAuth("IEmployeeManagerService/GetEmployeePayDetails", employeeId);
    }
    GetEmployeePayHistory(pEmployeePayHistoryParms: EmployeePayHistoryParms): Promise<EmployeePayHistoryViewModel[]> {
        return this.$apiService.sendAuth("IEmployeeManagerService/GetEmployeePayHistory", pEmployeePayHistoryParms);
    }
    GetEmployeeProfile(employeeId: string): Promise<EmployeeProfileViewModel> {
        return this.$apiService.sendAuth("IEmployeeManagerService/GetEmployeeProfile", employeeId);
    }
    GetEmployeeStatusCodes(): Promise<string[]> {
        return this.$apiService.sendAuth("IEmployeeManagerService/GetEmployeeStatusCodes");
    }
    GetEmployeeTaxDetails(employeeId: string): Promise<IEmployeeTaxViewModel[]> {
        return this.$apiService.sendAuth("IEmployeeManagerService/GetEmployeeTaxDetails", employeeId);
    }
    GetProfileSecurity(): Promise<EmployeeProfileSecurityViewModel> {
        return this.$apiService.sendAuth("IEmployeeManagerService/GetProfileSecurity");
    }
    GetSupervisedEmployees(supervisorEmployeeId: string): Promise<IEmployeeSummaryViewModel[]> {
        return this.$apiService.sendAuth("IEmployeeManagerService/GetSupervisedEmployees", supervisorEmployeeId);
    }
    PreSaveEmployeeProfileInfo(employeeViewModel: EmployeeProfileViewModel): Promise<ExecutionResult<any>> {
        return this.$apiService.sendAuth("IEmployeeManagerService/PreSaveEmployeeProfileInfo", employeeViewModel);
    }
}
